import React from 'react';
import { Control, UseFormWatch } from 'react-hook-form';
import { BaseCard } from '@/components/uiKit/Cards';
import { FormInput } from '@/components/pages/SettingsPage/MainContent/shared/FormInput';
import { UserProfileFormData } from '@/components/pages/SettingsPage/MainContent/shared/UserDetailsForm/UserDetailsForm';
import { useUserDetailsFormMode } from '@/components/pages/SettingsPage/MainContent/shared/UserDetailsForm/useUserDetailsFormMode';

interface PasswordSectionProps {
  control: Control<UserProfileFormData, any>;
  watch: UseFormWatch<UserProfileFormData>;
}

export const PasswordSection = ({ control, watch }: PasswordSectionProps) => {
  const { isCreateUserMode } = useUserDetailsFormMode();

  return (
    <BaseCard
      variant="wrapper"
      classNames={{
        card: `w-full`,
        title: 'h-[30px]',
        content: 'h-[calc(100%-30px)] rounded-lg overflow-y-hidden flex flex-row p-6',
      }}
      title="Password"
    >
      <div className="flex flex-col w-1/2 gap-4">
        <div className="flex flex-row w-full gap-4">
          <div className="flex-1">
            <FormInput
              name="password"
              type="password"
              control={control}
              label="New Passsword"
              rules={{ required: !isCreateUserMode ? false : 'Password is required' }}
            />
          </div>

          <div className="flex-1">
            <FormInput
              name="confirmPassword"
              type="password"
              control={control}
              label="Confirm New Password"
              rules={{
                required: !isCreateUserMode ? false : 'Confirm password is required',
                validate: (value: string) => {
                  if (watch('password') !== value) {
                    return 'Your passwords do not match';
                  }
                },
              }}
            />
          </div>
        </div>
      </div>
    </BaseCard>
  );
};
